<template>
	<div>
		<Modal :open-state="show" @close="() => show = false" title="Создание аккаунта" id="modalSignUp">
			<div>
				<button @click="$root.OAuth('vkontakte')" class="btn btn--lg btn--outline-vkontakte btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-vk"></use></svg>
					Регистрация через Вконтакте
				</button>

				<button @click="$root.OAuth('telegram')" class="btn btn--lg btn--outline-telegram btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-tg"></use></svg>
					Регистрация через Телеграм
				</button>
				<button @click="$root.OAuth('google')" class="btn btn--lg btn--outline-google btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-google"></use></svg>
					Регистрация через Google
				</button>
				<button @click="$root.OAuth('mailru')" class="btn btn--lg btn--outline-mailru btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-mailru"></use></svg>
					Регистрация через mail.ru
				</button>
				<button @click="$root.OAuth('yandex')" class="btn btn--lg btn--outline-yandex btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-yandex"></use></svg>
					Регистрация через Yandex
				</button>

				<div class="fields__item">
					Создавая аккаунт и пользуясь услугами сайта, вы соглашаетесь с <a href="terms" target="_blanc">Правилами сайта</a>.
					<p>Регистрировать более 1-го аккаунта запрещено. Все мультиаккаунты блокируем.</p>
				</div>
				<div v-if="errors.show" class="alert alert--danger fields__item" role="alert">
					{{ errors.message }}
				</div>
				<div class="text-center">Есть аккаунт? <a class="link" @click="handlerSingIn">Войти</a></div>
			</div>
		</Modal>
	</div>
</template>

<script>
    import Modal from "../blocks/Modal.vue";

	export default {
		components: {
			Modal
		},
        data() {
            return {
                username: '',
                password: '',
                password_confirm: '',
                errors: {
                    show: false,
                    message: ''
                },
                disableBtn: false,
				show: false
            }
        },

		mounted() {
			this.$root.emitter.on('showModalSignUp', () => this.show = true);
		},

		methods: {
			handlerSingIn() {
				this.show = false;
				setTimeout(() => {
					this.$root.emitter.emit('showModalSignIn');
				},300)
			}
		}
	}
</script>